/** @jsxImportSource @emotion/react */
'use memo'

import { LaptopOutlined } from '@ant-design/icons'
import EmptyStateBox from 'src/components/ts-components/EmptyStateBox'

const NoTeamFinderResults = () => (
  <EmptyStateBox
    icon={<LaptopOutlined />}
    title='No Teams Found'
    subtitle="We couldn't find any teams matching your filters. Try widening your search or clearing a filter."
  />
)

export default NoTeamFinderResults
